
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 56 56.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M3.949 38.501A3.973 3.973 0 010 34.588V3.938A3.977 3.977 0 014.024.001h42.727a3.951 3.951 0 014 3.912v8.338a1.75 1.75 0 01-3.5 0V3.938c0-.233-.183-.4-.475-.437H3.992a.474.474 0 00-.492.462v30.6a.449.449 0 00.477.438H19.25a1.75 1.75 0 010 3.5H3.949zm31.926 5.25a2.625 2.625 0 112.625-2.625 2.629 2.629 0 01-2.625 2.625zm0-3.5a.875.875 0 10.875.875.877.877 0 00-.875-.875zm8.75 3.5a2.625 2.625 0 112.625-2.625 2.629 2.629 0 01-2.625 2.625zm0-3.5a.875.875 0 10.875.875.877.877 0 00-.875-.875zm-8.75 10.5a2.625 2.625 0 112.625-2.625 2.629 2.629 0 01-2.625 2.625zm0-3.5a.875.875 0 10.875.875.877.877 0 00-.875-.875zm8.75 3.5a2.625 2.625 0 112.625-2.625 2.629 2.629 0 01-2.625 2.625zm0-3.5a.875.875 0 10.875.875.877.877 0 00-.875-.875z"}}),_c('path',{staticClass:"a",attrs:{"d":"M46.249 35.001h-12a2.794 2.794 0 01-2.749-2.959v-4.624a2.775 2.775 0 012.753-2.917h12A2.743 2.743 0 0149 27.418v4.667a2.775 2.775 0 01-2.751 2.916zM35 31.501h10.5v-3.5H35z"}}),_c('path',{staticClass:"a",attrs:{"d":"M54.25 56.001h-28a1.75 1.75 0 01-1.75-1.75v-35a1.751 1.751 0 011.75-1.75h28a1.75 1.75 0 011.75 1.75v35a1.749 1.749 0 01-1.75 1.75zM28 52.501h24.5v-31.5H28zm-19.25-31.5a1.75 1.75 0 01-1.237-2.987l5.25-5.25a1.751 1.751 0 012.02-.328l5.871 2.936 7.859-7.858a1.75 1.75 0 012.474 2.474l-8.75 8.75a1.748 1.748 0 01-2.02.328l-5.871-2.936-4.359 4.358a1.741 1.741 0 01-1.237.513z"}}),_c('path',{staticClass:"a",attrs:{"d":"M29.75 15.751a1.751 1.751 0 01-1.75-1.75v-3.5h-3.5a1.75 1.75 0 010-3.5h5.25a1.75 1.75 0 011.75 1.75v5.25a1.75 1.75 0 01-1.75 1.75z"}})])
          )
        }
      }
    